<template>
  <div>
    <AppNewHeader
      :userName="userName"
      style="width: 100%"
      :placeholderText="'搜索知识资源'"
    />
    <div class="dljg_banner">
      <h1>守护创意 尊重原创</h1>
    </div>
    <div class="wrap">
      <div class="titles">版权声明</div>
      <div class="contentHeader">
        <div class="tabheader">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            class="tabitem"
            :class="{ active: activeTab === index }"
            @click="handleTabClick(index)"
          >
            {{ tab }}
          </div>
        </div>
      </div>
      <div class="bqtitletext">
        <p>
          “亿知知识库”
          平台所上架的全部数字知识产品，均系出版机构正规授权的合法出版物。为保护知识产权，平台郑重声明如下：
        </p>
      </div>

      <div
        v-for="(content, index) in contents"
        :key="index"
        class="contentList"
      >
        <div
          class="contentItem"
          :class="{ 'fourth-content-item': index === 3 }"
        >
          <div class="itemback">{{ index + 1 }}</div>
          <div class="text">
            <p class="title" :class="{ active: activeTab === index }">
              {{ content.title }}
            </p>
            <p class="itemtext">{{ content.text }}</p>
            <div v-if="index === 3" class="infringe">
              <p>联系方式</p>
              <div class="infringeitem"><span>邮箱：sale@yizhi.com </span></div>
              <div class="infringeitem"><span>电话： 029-81298926 </span></div>
              <div class="infringeitem">
                <span
                  >书面函件地址：陕西省西安市雁塔区锦业路10号中投国际B座1507</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-footer>
      <div>
        <AppFooter />
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import AppFooter from "@/views/components/AppFooter.vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import { ref, onMounted, onUnmounted } from "vue";
import { Cookie } from "@/utils/Cookie";
import { getBuyLog } from "@/api/index.js";
import { usePageStayTime } from "@/utils/usePageStayTime";

const { stayTime, totalStayTimes } = usePageStayTime();
const tabindex = ref("1");
const tabs = ref(["版权归属", "使用限制", "侵权处理", "合作申明"]);
const weburl = ref(window.location.href)
const contents = ref([
  // {
  //   title: "版权申明",
  //   text: "“亿知知识库”平台所上架的全部数字知识产品,均系出版机构正规授权的合法出版物。",
  // },
  {
    title: "版权归属",
    text: "所有数字产品的著作权、版权及相关权益均归属原始出版机构或合法权利人所有，平台仅提供展示与技术储存服务。",
  },
  {
    title: "使用限制",
    text: "部分产品因合作权限限制，仅作内容展示，暂不开放销售或下载功能。",
  },
  {
    title: "侵权处理",
    text: "如出版机构或权利人认为平台内容侵犯其合法权益，请通过以下方式联系我们，我们将第一时间核实并下架处理：",
  },
  {
    title: "合作申明",
    text: "平台正积极与出版机构推进资源合作，扩大授权范围。欢迎出版方联系洽谈合作事宜。本声明最终解释权归“亿知知识库”所有。",
  },
]);

const activeTab = ref(0);

const handleTabClick = (index) => {
  activeTab.value = index;
  tabindex.value = index;
};

const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "8",
       url: weburl.value,
      text: tabindex.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
const hiddenTime = ref(Number);

window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "8",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});

onMounted(() => {
  checkTokenStatus();
});
onUnmounted(async () => {
  await handleLog();
});
</script>

<style scoped>
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}

.dljg_banner {
  background: url(../../assets/newimages/copy.png) no-repeat top center #3040d1;
  height: 200px;
  background-size: cover;
  background-repeat: no-repeat;
}

.wrap {
  width: 100%;
  /* height: 1012px; */
  margin: 0 auto;
  margin-bottom: 80px;
  /* margin-bottom: 20px; */
}
.tabheader {
  width: 839px;
  height: 37px;
  display: flex;
  justify-content: space-between;
}
.contentHeader {
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: center;
  /* margin-top: 44px; */
}
.tabitem {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: right;
  font-style: normal;
  width: 72px;
  cursor: pointer;
}
.tabitem.active {
  color: #2c77ff;
  border-bottom: 2px solid #2c77ff;
}
.contentList {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.contentItem {
  width: 1400px;
  display: flex;
  justify-content: flex-start;
  height: 64px;
  margin-top: 40px;
  margin: 0 auto;
}
.contentItem.fourth-content-item {
  width: 1400px;
  height: auto;
  margin: 0 auto;
}
.contentItem2 {
  width: 1400px;
  display: flex;
  justify-content: flex-start;
  height: auto;
  margin-top: 40px;
}
.itemback {
  width: 40px;
  height: 40px;
  background-image: url(@/assets/image/copyicon.png);
  background-repeat: no-repeat;
  background-size: cover;
  line-height: 37px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
}
.text {
  /* padding-left: 16px; */
}
.title {
  /* padding-left: 10px; */
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: justify;
  font-style: normal;
  padding: 7px 16px 10px;
}
.title.active {
  color: #2c77ff;
}
.itemtext {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
  padding-left: 16px;
}
.infringe {
  width: 450px;
  background: #ebf3ff;
  padding: 20px;
  margin-top: 16px;
  margin-left: 16px;
}
.infringe p {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
}
.infringe-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.infringeitem span {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  text-align: justify;
  font-style: normal;
}
.dljg_banner h1 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 36px;
  color: #ffffff;
  line-height: 204px;
  text-align: left;
  font-style: normal;
  margin-left: 316px;
}
.bqtitletext {
  width: 100%;
  display: flex;
  justify-content: left;
}
.bqtitletext p {
  width: 1400px;
  text-align: center;
  /* padding-left: 78px; */
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  font-style: normal;
}
.titles {
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  line-height: 33px;
  font-style: normal;
  padding: 40px 0 24px 0;
}
</style>
